import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapPageBreakSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcappagebreak: {
      group: 'block',
      parseDOM: [
        { tag: 'MadCap\\:pageBreak' }
      ],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:pageBreak',
      isTagNameBox: true,
      isVoid: true
    }
  } satisfies Record<string, NodeSpec>;
}
